import { render, staticRenderFns } from "./freelancer.vue?vue&type=template&id=7dcbb856&scoped=true&"
import script from "./freelancer.vue?vue&type=script&lang=js&"
export * from "./freelancer.vue?vue&type=script&lang=js&"
import style0 from "./freelancer.vue?vue&type=style&index=0&id=7dcbb856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcbb856",
  null
  
)

export default component.exports